
export enum Frequency {
    Fortnight,
    Month,
    Year
}
